export default {
    path: '/parcerias',
    name: 'Partnerships',
    component: () => import("@/presentation/views/Partnerships/Partnerships.vue"),
    redirect: { name: 'PartnershipsList' },
    meta: { requiresAuth: true },
    list: {
        path: "lista",
        name: "PartnershipsList",
        component: () =>
            import("@/presentation/views/Partnerships/PartnershipsList/PartnershipsList.vue"),
    },
    detail: {
        path: "detalhes/:id",
        name: "PartnershipDetail",
        props: true,
        component: () =>
            import("@/presentation/views/Partnerships/PartnershipDetail/PartnershipDetail.vue"),
    },
    add: {
        path: "adicionar",
        name: "AddPartnership",
        component: () =>
            import("@/presentation/views/Partnerships/AddPartnership/AddPartnership.vue"),
    },
    edit: {
        path: "editar/:id",
        name: "EditPartnership",
        props: true,
        component: () =>
            import("@/presentation/views/Partnerships/EditPartnership/EditPartnership.vue"),
    },
    addUser: {
        path: "detalhes/:id/adicionar-usuario",
        name: "AddPartnerUser",
        props: true,
        component: () =>
            import("@/presentation/views/Partnerships/PartnershipDetail/AddPartnerUser.vue"),
    }
} as const